export const createPurchaseIdempotencyKey = (documentType, userID) => {
    const randomPart = window.crypto?.randomUUID?.()
        || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    return `PURCHASE-${documentType}-${userID || 0}-${randomPart}`;
};
